import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Sparkles } from 'lucide-react';
import PlanBadge from './PlanBadge';

const RESOURCE_LABELS = {
  seats: 'kullanıcı',
  projects: 'proje',
  invites: 'davet',
};

export default function UpgradeModal({ open, info, onClose }) {
  const navigate = useNavigate();
  if (!open || !info) return null;

  const resource = RESOURCE_LABELS[info.resource] || 'kaynak';
  const limit = info.limit ?? '—';
  const current = info.current ?? '—';

  const goToPricing = () => {
    onClose?.();
    navigate(info.upgradeUrl || '/pricing');
  };

  return (
    <div className="ox-modal-backdrop" onClick={onClose} style={{
      position: 'fixed', inset: 0, background: 'rgba(15, 23, 42, 0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100,
      animation: 'oxFadeIn .15s ease',
    }}>
      <div
        className="ox-surface rounded-md"
        onClick={(e) => e.stopPropagation()}
        style={{ width: 'min(420px, 92vw)', padding: 24, position: 'relative', animation: 'oxSlideUp .2s cubic-bezier(.2,.8,.2,1)' }}
      >
        <button onClick={onClose} className="absolute" style={{ top: 12, right: 12, color: 'var(--text-muted)' }}>
          <X size={18} />
        </button>

        <div className="flex items-center gap-2 mb-3">
          <div className="rounded-full p-2" style={{ background: 'var(--accent-weak)', color: 'var(--accent)' }}>
            <Sparkles size={18} />
          </div>
          <div className="text-[15px] font-semibold">Plan limitine ulaştınız</div>
        </div>

        <p className="text-[13px] ox-text-muted mb-4" style={{ lineHeight: 1.55 }}>
          {info.plan && (
            <>Mevcut planınız <PlanBadge plan={info.plan} /> bu workspace için <strong>{limit}</strong> {resource} sınırı içeriyor.<br /></>
          )}
          Kullanım: <strong>{current}/{limit}</strong>. Devam etmek için planınızı yükseltmeniz gerekiyor.
        </p>

        <div className="flex items-center gap-2 justify-end mt-5">
          <button onClick={onClose} className="ox-btn">İptal</button>
          <button onClick={goToPricing} className="ox-btn ox-btn-primary">Planları Görüntüle</button>
        </div>
      </div>
    </div>
  );
}
